import SliderImage1 from "../../assets/images/png/home/individual-2.webp";
import SliderImage2 from "../../assets/images/png/home/business-2.webp";
import SliderImage3 from "../../assets/images/png/home/impact-2.webp";
import PersonIcon from "../../assets/images/svg/person.svg";
import BusinessIcon from "../../assets/images/svg/business.svg";
import ImpactIcon from "../../assets/images/svg/love.svg";

export const europe = [
  {
    id: 1,
    image: SliderImage1,
    icon: PersonIcon,
    title: "For Individual",
    description: `
      On the Utiva Platform, access the best tech skill 
      training that comes with deep-dive mentoring, coaching and real projects 
            `,
    linkUrl: "/get-started",

    stats: [
      {
        name: "Students Trained",
        value: "32K+",
      },
      {
        name: "Hiring Rate",
        value: "85% ",
      },
      {
        name: "Countries",
        value: "30",
      },
    ],
  },
  {
    id: 2,
    image: SliderImage2,
    icon: BusinessIcon,
    title: "For Business",
    description: `
      Utiva offers companies the technology, contents, and 
      the best training approaches that help drive workforce development
            `,
    linkUrl: "/business",
    stats: [
      {
        name: "Students Trained",
        value: "15K",
      },
      {
        name: "Apprenticeship",
        value: "90% ",
      },
      {
        name: "Projects Completed",
        value: "500+",
      },
    ],
  },
  {
    id: 3,
    image: SliderImage3,
    icon: ImpactIcon,
    title: "For Impact",
    description: `
      Working with some of the top social impact funding partners 
      like HP, Act Foundation, we have taken talent development to over 60 new cities and locations
            `,
    linkUrl: "https://impact.utiva.io",
    stats: [
      {
        name: "Students Trained",
        value: "25K",
      },
      {
        name: "Training Completed",
        value: "95% ",
      },
      {
        name: "Major Partners",
        value: "35",
      },
    ],
  },
];
